import { useEffect } from 'react';

const BASE_TITLE = 'Pun and Done!';

// Sets document.title for the route that renders it, then renders nothing.
// Replaces react-helmet, which is unmaintained and warns on React 19.
// The default title and description live in public/index.html; every route
// below sets its own title, so there is no cleanup to do on unmount.
function PageTitle({ title }: { title: string }) {
  useEffect(() => {
    document.title = `${title} | ${BASE_TITLE}`;
  }, [title]);

  return null;
}

export default PageTitle;
